import { useEffect, useState } from 'react'
import { api } from '../api.js'
import MiseEnRoute from '../components/MiseEnRoute.jsx'

const COULEURS = { b: '#2e5bd4', g: '#0e7a54', r: '#c1122b', a: '#a56a00', n: '#8794ab' }

export default function TableauDeBord({ onOuvrir, onAller, droits }) {
  const [d, setD] = useState(null)

  useEffect(() => { api.dashboard().then(setD).catch(() => setD(null)) }, [])
  if (!d) return <p className="chargement">Chargement…</p>

  const total = d.by_status.reduce((n, s) => n + s.count, 0) || 1

  return (
    <>
      <h1>Tableau de bord</h1>
      <p className="chapo">Ce qui attend, ce qui presse, et ce qui arrive cette semaine.</p>

      <MiseEnRoute onAller={onAller} droits={droits} />

      <div className="kpis">
        <Kpi label="Dossiers en cours" valeur={d.open} detail={`sur ${d.total} déposés au total`}
             onClick={() => onAller('dossiers')} />
        <Kpi label="À traiter en priorité" valeur={d.hot}
             detail={d.hot ? 'signalés par le circuit' : 'rien de brûlant'} alerte={d.hot > 0} />
        <Kpi label="En attente de l'habitant" valeur={d.awaiting} detail="complément demandé" />
        <Kpi label="Sans mouvement depuis 5 jours" valeur={d.dormant}
             detail={d.dormant ? 'à relancer' : 'aucun dossier oublié'} alerte={d.dormant > 0} />
      </div>

      <div className="deux">
        <section className="carte">
          <h2>Derniers dossiers</h2>
          <table className="tableau">
            <thead><tr><th>Numéro</th><th>Démarche</th><th>Demandeur</th><th>Étape</th></tr></thead>
            <tbody>
              {d.recent.map((r) => (
                <tr key={r.id} onClick={() => onOuvrir(r.id)} tabIndex={0}
                    onKeyDown={(e) => e.key === 'Enter' && onOuvrir(r.id)}>
                  <td className="mono">{r.number}</td>
                  <td><strong>{r.title}</strong></td>
                  <td>{r.applicant}</td>
                  <td><span className="etat">{r.status}</span></td>
                </tr>
              ))}
              {!d.recent.length && <tr><td colSpan={4} className="vide">Aucun dossier pour l'instant.</td></tr>}
            </tbody>
          </table>
        </section>

        <aside>
          <div className="carte">
            <h2>Répartition par étape</h2>
            {d.by_status.length ? (
              <>
                <div className="jauge">
                  {d.by_status.map((s) => (
                    <i key={s.label} style={{ width: `${(s.count / total) * 100}%`,
                                              background: COULEURS[s.tone] || COULEURS.n }} />
                  ))}
                </div>
                <ul className="legende">
                  {d.by_status.map((s) => (
                    <li key={s.label}>
                      <span className="pastille" style={{ background: COULEURS[s.tone] || COULEURS.n }} />
                      <span>{s.label}</span><b>{s.count}</b>
                    </li>
                  ))}
                </ul>
              </>
            ) : <p className="aide">Aucun dossier en cours.</p>}
          </div>

          <div className="carte">
            <h2>Prochains rendez-vous</h2>
            {d.bookings.length ? d.bookings.map((b, i) => (
              <div className="rdv-ligne" key={i}>
                <span className="mono">{new Date(b.day).toLocaleDateString('fr-FR')}</span>
                <span className="heure">{b.time}</span>
                <span className="qui">{b.name}</span>
                {b.request_id && (
                  <button className="btn sm" onClick={() => onOuvrir(b.request_id)}>Voir</button>
                )}
              </div>
            )) : <p className="aide">Aucun rendez-vous réservé.</p>}
          </div>
        </aside>
      </div>
    </>
  )
}

function Kpi({ label, valeur, detail, onClick, alerte }) {
  const Balise = onClick ? 'button' : 'div'
  return (
    <Balise className={`kpi ${alerte ? 'alerte' : ''}`} onClick={onClick}>
      <span className="lbl">{label}</span>
      <strong>{valeur}</strong>
      <span className="detail">{detail}</span>
    </Balise>
  )
}
